// extracted by mini-css-extract-plugin
module.exports = {"slider":"a2c79c7e7d--slider--uGdw7","slide":"a2c79c7e7d--slide--muHxF","transition":"a2c79c7e7d--transition--TG0UZ","preloader":"a2c79c7e7d--preloader--IuYWG"};